<template>
  <div class="ibox">

    <div class="mb-2 ibox-title pt-3">
      <h5><strong>Empresa associadas a este fornecedor</strong></h5>
    </div>

    <div class="ibox-content">

      <div class="row mt-4">
        <div class="col-md-6">
          <input v-model="query.generic" class="input form-control"
                 @keypress.enter="find()"
                 placeholder="Pesquisar por: Nome ou CNPJ">
          <search-icon @click="find()" class="icon icon-within"/>
        </div>
        <div class="col-md-6">
          <button class="btn btn-primary mr-2" @click="addOrRemoveManyCompanies()">
            Adicionar todas as empresas
          </button>
          <button class="btn btn-primary" @click="addOrRemoveManyCompanies('remove')">
            Remover todas as empresas
          </button>
        </div>
      </div>

      <Table :company="provider" :companies="companies" @checked="checkCompany($event)"/>

      <div class="row">
        <div class="col-md-12 my-1">
          <Pagination
            v-model="params.page"
            :total-count="meta.totalCount"
            :total-pages="meta.totalPages"
            @pagination="pagination"
          />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import handleSearchable from '@/models/handleSearchable'
  import Table from '@/components/providers/container/card/TableProviderCompany'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { SearchIcon } from 'vue-feather-icons'

  export default {
    components: { Pagination, SearchIcon, Table },
    computed: {
      companies() {
        return this.getModels || []
      }
    },
    created() {
      this.query.type = ['parent', 'subsidiary']
      this.methods = ['provider_ids']
      this.find()
    },
    data() {
      return {
        currentProvider: {},
        lastGenericSearch: '',
        nameModel: 'Company'
      }
    },
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        return ModelMapper.methods.buildParams.call(this, pagination)
      },
      async addOrRemoveManyCompanies(option = 'add') {
        if (!confirm('Tem certeza que deseja associar todas as empresas neste fornecedor?'))
          return

        const method = option === 'add' ? 'add_ids' : 'remove_ids'
        const provider = { id: this.provider.id }

        if (typeof this.lastGenericSearch === 'string' && this.lastGenericSearch.length > 0) {
          const params = {
            fields: 'id',
            meta: false,
            q: { generic: this.lastGenericSearch }
          }

          const response = await this.axios.get(this.modelPath, { params })
          const ids = response.data.map(obj => obj.id)
          provider.companies = { [method]: ids }
        } else {
          provider.companies = { [method]: '*' }
        }

        await this.asyncTemplateSave(provider, {
          after: () => this.find()
        })
      },
      checkCompany(company) {
        const provider = { id: this.provider.id }

        if (company.checked) {
          provider.providers = { add_ids: company.id }
        } else {
          provider.providers = { remove_ids: company.id }
        }
        this.save(provider)
      },
      find() {
        this.asyncTemplateSelect({
          after: ({models}) => {
            this.updateCompanies(models)
            this.lastGenericSearch = this.query.generic
          }
        })
      },
      pagination(page) {
        this.params.page = page
        this.asyncTemplateSelect({
          after: ({models}) => this.updateCompanies(models),
          pagination: true
        })
      },
      save(company) {
        this.asyncTemplateSave(company)
      },
      updateCompanies(companies) {
        companies.forEach(company => {

          if (company.providerIds.includes(this.provider.id))
            this.$set(company, 'checked', true)
          else
            this.$set(company, 'checked', false)
        })
      }
    },
    mixins: [ModelMapper],
    name: 'CardCompanies',
    props: {
      provider: { required: true, type: Object },
    }
  }
</script>

<style scoped>

  p {
    color: black;
  }

  .table td {
    vertical-align: middle;
  }
</style>
